/**
 * Cart Items Component
 */

'use client';

import { CartItem } from '../CartItem/CartItem';
import { PackCartGroup } from '../PackCartGroup';
import type { CartItemEntity } from '@/domain/entities/cart.entity';
import { groupCartItems } from '@/lib/cart/group-cart-items';

export interface CartItemsProps {
  items: CartItemEntity[];
  isLoading?: boolean;
  onQuantityChange: (
    productId: string,
    variantId: string,
    quantity: number,
    lineId?: string,
  ) => void;
  onRemove: (productId: string, variantId: string, lineId?: string) => void;
  onPackQuantityChange: (packId: string, quantity: number) => void;
  onPackRemove: (packId: string) => void;
}

export function CartItems({
  items,
  isLoading,
  onQuantityChange,
  onRemove,
  onPackQuantityChange,
  onPackRemove,
}: CartItemsProps) {
  if (items.length === 0) {
    return null;
  }

  const groups = groupCartItems(items);

  return (
    <div>
      {groups.map((group, index) =>
        group.kind === 'pack' ? (
          <PackCartGroup
            key={`pack-${group.packId}-${index}`}
            packId={group.packId}
            items={group.items}
            isLoading={isLoading}
            onPackQuantityChange={onPackQuantityChange}
            onPackRemove={onPackRemove}
          />
        ) : (
          <CartItem
            key={group.item.id}
            item={group.item}
            isLoading={isLoading}
            onQuantityChange={(quantity) =>
              onQuantityChange(
                group.item.product_id,
                group.item.variant_id,
                quantity,
                group.item.line_id,
              )
            }
            onRemove={() =>
              onRemove(group.item.product_id, group.item.variant_id, group.item.line_id)
            }
          />
        ),
      )}
    </div>
  );
}
